import type { DashboardType } from "web_myplann/Dashboard/Types/DashboardType";

type DashboardValueSource = Pick<
	DashboardType,
	"itemCount" | "itemCountWithoutValue" | "evaluation"
>;

export type DashboardValueState = {
	isMissingValueWithItems: boolean;
	evaluation: number | undefined;
};

export const getDashboardValueState = ({
	itemCount,
	itemCountWithoutValue,
	evaluation,
}: DashboardValueSource): DashboardValueState => {
	const itemCountWithValue = itemCount - itemCountWithoutValue;
	const isMissingValueWithItems =
		itemCountWithValue <= 0 && itemCountWithoutValue > 0;

	return {
		isMissingValueWithItems,
		evaluation: isMissingValueWithItems ? undefined : evaluation,
	};
};
